import { rankingData } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-screen-2xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-3">
          热播榜单
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          实时热度排行，发现大家都在看的精彩内容
        </p>
        <div className="max-w-2xl mx-auto bg-background-50 rounded-lg overflow-hidden">
          {rankingData.map((item, i) => (
            <div
              key={item.rank}
              className={`flex items-center gap-4 p-4 md:p-5 cursor-pointer hover:bg-background-100 transition-colors ${
                i < rankingData.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-full text-sm font-bold flex-shrink-0 ${
                item.rank === 1
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-primary-500 text-background-50'
                  : item.rank === 3
                  ? 'bg-secondary-500 text-background-50'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900">{item.title}</h3>
                <span className="text-xs text-foreground-400">{item.type}</span>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-sm font-medium text-accent-600">{item.heat}</span>
                {item.trend === 'up' && <i className="ri-arrow-up-fill text-accent-500 text-sm"></i>}
                {item.trend === 'down' && <i className="ri-arrow-down-fill text-foreground-400 text-sm"></i>}
                {item.trend === 'new' && <span className="px-2 py-0.5 text-xs font-medium text-accent-700 bg-accent-100 rounded-full whitespace-nowrap">NEW</span>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}